import React, { Component } from "react";
import { connect } from "react-redux";
import { getAllSpecificatios } from "../actions/filesActions";
import { Container, Row, Col } from "reactstrap";
import ListView from "../Components/ListView";
import Specification from "./Specification";
import downloadButton from "./downloadAllSpecificationsButton";
import FilesLinkColumn from "./filesLinkColumn";

class AllSpecifications extends Component {
  state = {
    data: [],
    tableSettings: {
      columns: [
        {
          property: "name",
          displayString: "מספר ושם הפרק",
          size: "2"
        },
        {
          image: "edition",
          property: "numberOfEditions",
          displayString: "מספר מהדורות",
          size: "2"
        },
        {
          image: "fix",
          property: "numberOfFixes",
          displayString: "מספר דפי תיקון",
          size: "2"
        },
        {
          property: "publishAt",
          displayString: "תאריך עידכון אחרון",
          size: "2"
        },
        {
          type: "fileLink",
          component: FilesLinkColumn,
          property: "",
          displayString: "קבצים להורדה (להורדה לחץ על שם הקובץ)",
          size: "4"
        }
      ],
      rowIsLink: true
    },
    displayOptions: {
      viewName: { firstLine: "כל", secondLine: "הפרקים" },
      buttonComponent: downloadButton,
      displaySortByCategory: false,
      categoryText: "מציג לפי מספר פרק",
      listName: "allSpecifications"
    },
    cubesSettings: {
      componentName: Specification
    }
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.data.length > 0) {
      this.setState({ data: nextProps.data });
    }
  }

  componentDidMount() {
    this.props.onLoadData();
  }

  render() {
    return (
      <Container>
        <Row>
          <Col>
            <ListView viewData={this.state} data={this.state.data} />
          </Col>
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = state => {
  return {
    data: state.files.allSpecifications
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onLoadData: () => dispatch(getAllSpecificatios())
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AllSpecifications);
